const currentPackageSelector = state => state.entities.packageInformation && Object.values(state.entities.packageInformation)[0];

export default currentPackageSelector;
